(function () {
  try {
    const params = new URLSearchParams(window.location.search);
    const promoCodeFromQuery = params.get("promo_code");
    if (promoCodeFromQuery) {
      setCookie("selected_promo_code", promoCodeFromQuery, 1);
      appendCouponToCookie(promoCodeFromQuery);
    }
  } catch (e) {
    logger.error(e);
  }
})();

class CouponCodeMessage extends HTMLElement {
  constructor() {
    super();
    this.discountCodeElement = this.querySelector(
      ".cart-discount-message__code"
    );
    this.initDiscountCodeMessage();
  }
  initDiscountCodeMessage() {
    const promoCode = getCookie("selected_promo_code");
    if (promoCode && this.discountCodeElement) {
      this.discountCodeElement.innerHTML = promoCode.toUpperCase();
      this.style.display = "block";
    }
  }
}
customElements.define("cart-discount-message", CouponCodeMessage);
